import { Injectable } from '@angular/core';
import axios from 'axios';
import { environment } from 'src/environments/environment';

export type InvoiceOcr = {
  client_type: 'org' | 'house';
  client_country_iso: string | null;
  client_postcode: string | null;
  client_city: string | null;
  client_street: string | null;
  client_tax_number: string | null;
  client_name: string | null;
  debtor_type: 'org' | 'ind';
  debtor_country_iso: string | null;
  debtor_postcode: string | null;
  debtor_city: string | null;
  debtor_street: string | null;
  debtor_tax_number: string | null;
  debtor_name: string | null;
  claim_original_amount: number | null;
  currency_iso: string | null;
  claim_due_date_at: string | null;
  invoice_number: string | null;
  invoice_issued_at: string | null;
  claim_type_internal_id: string | null;
};

export const INVOICE_OCR_TIMEOUT = 15_000;

@Injectable({
  providedIn: 'root'
})
export class InvoiceOcrService {
  async parseInvoice(file: File): Promise<InvoiceOcr> {
    const url = `${environment.baseUrl}/api/case-form/invoice-ocr`;
    const data = new FormData();
    data.append('file', file);

    const response = await axios.post<InvoiceOcr>(url, data, {
      timeout: INVOICE_OCR_TIMEOUT,
    });

    return response.data;
  }
}
